// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import {Link, Tooltip} from '@bonprix/design-system';
import ProductMessages from './message-list';
import Icon from '@bonprix/pattern-library/templates/icon';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Typography} from '@bonprix/design-system';
import Toggles from "@core/scripts/modules/toggles";
import Benefits from "./benefits/Benefits.jsx";

let tooltipOpenLandmarkSent;

export default function Price({product, texts, staticLinks, fullWidth}) {
    const [currentItem, setCurrentItem] = useState(product.currentItem);
    const [currentItemOption, setCurrentItemOption] = useState(product.currentItemOption);

    useEffect(() => {
        const subscription = MessageBroker.subscribe(ProductMessages.CHANGED, ({item, itemOption}) => {
            if (item !== undefined) {
                setCurrentItem(item);
            }
            if (itemOption !== undefined) {
                setCurrentItemOption(itemOption);
            }
        });

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    const sendTooltipOpenLandmark = () => {
        if (!tooltipOpenLandmarkSent) {
            Landmark.sendClickLandmark('adp_shippingcost');
            tooltipOpenLandmarkSent = true;
        }
    };

    const sendMoreInfoLandmark = () => {
        Landmark.sendClickLandmark('adp_shippingcost_info');
    };

    const getMoreInfoLink = (staticLinks, texts) => {
        return (
            <div
                key={3}
                className="product__delivery-more-info">
                <Link
                    arrowPosition={'right'}
                    showArrow
                    href={staticLinks.deliveryCostsMoreInfoUrl}
                    target="_blank"
                    onClick={sendMoreInfoLandmark}
                >
                    {texts.bbff_ada_info_shipping_information_more_info}
                </Link>
            </div>
        );
    };

    const price = product.coliCount > 0 ? currentItem.price : (currentItemOption || currentItem).price;
    const currentPrice = (
        <Typography variant="h2" component="div">
            <div
                className={
                    'product__price' +
                    (price.current.unknownPrice ? ' -unknown' : '') +
                    (price.former ? ' -reduced' : '')
                }
            >
                {price.current.uniquePrice ? null : <div className="product__multiple-prices">{texts.au_ab}</div>}
                <span key={`product-price-${currentItem?.id}`}>{price.current.value}</span>
            </div>
        </Typography>
    );

    const renderFormerPrice = (price) => {
        if (!price?.former) {
            return null;
        }

        return (
            <Typography variant="h5" component="span">
                <span className="product__former-price">
                    {price.former.uniquePrice ? null : texts.au_ab + ' '}
                    {price.former.value}
                </span>
                <span className="product__price-reduction">-{price.current.reduction}%</span>
            </Typography>
        );
    };

    const renderSquareMeterPrice = (price) => {
        if (!price?.perSquareMeter) {
            return null;
        }

        return (
            <div className={'product__square-meter-price' + (price.former ? ' -reduced' : '')}>
                {price.perSquareMeter.uniquePrice ? null : texts.au_ab + ' '}
                {price.perSquareMeter.value}
            </div>
        );
    };

    const renderDeliveryInformation = (price) => {
        if (price?.current.unknownPrice) {
            return (
                <div className="product__delivery-info-container">
                    <Typography variant="body1">
                        <div className="product__price-unavailable">{texts['ada_price-not-available']}</div>
                    </Typography>
                </div>
            );
        } else {
            const tooltipContent = (
                <Typography variant="body1" component="span">
                    {texts.bff_ada_info_shipping_information_charges}
                    {product.additionalDeliveryInfo && <div key={1}>{product.additionalDeliveryInfo}</div>}
                    {getMoreInfoLink(staticLinks, texts)}
                </Typography>
            );

            return (
                <div className={'product__delivery-info-container'}>
                    <Typography variant="body1" component="div">
                        <div className="product__delivery-text">
                            {texts.bff_ada_tax_included}&nbsp;
                            <span className="product__delivery-tooltip-wrapper" onMouseEnter={sendTooltipOpenLandmark}>
                                <Tooltip content={tooltipContent}>
                                    <span className="product__delivery-tooltip-label">
                                        <span className="product__delivery-costs">
                                                {currentItem?.carrierExtraCharge
                                                    ? texts.bff_ada_info_icon_shipping_bigsize_headline
                                                    : texts.bff_ada_info_icon_shipping_headline}
                                        </span>
                                        <Icon name="hint" className="product__delivery-tooltip-icon"/>
                                    </span>
                                </Tooltip>
                            </span>
                        </div>
                    </Typography>
                </div>
            );
        }
    };

    const renderPricePerItem = (price) => {
        if (!price.perItem || !Toggles.isEnabled('PDP_PRICE_PER_ITEM')) {
            return null;
        }

        return (
            <div className="product__prices-per-item">
                <Typography variant="body2" component="span"
                            color="on-bg-low">{price.current?.packItemsCount} {texts.au_piece}</Typography>
                <span className="product__prices-per-item-seperator"><Typography variant="body2" component="span"
                                                                                 color="on-bg-low">|</Typography></span>
                <Typography variant="body2" component="span" color="on-bg-low">{price.perItem.value} {texts.au_unit_price}</Typography>
            </div>
        );
    };

    return (
        <div className={fullWidth ? "product__prices-container__full_width" : "product__prices-container"}>
            <div className={'product__prices' + (price.former ? ' -full-width' : '')}>
                {currentPrice}
                {renderSquareMeterPrice(price)}
                {renderFormerPrice(price)}
            </div>
            {renderPricePerItem(price)}
            {renderDeliveryInformation(price)}
        </div>
    );
}
